<div class="d-flex align-items-start">
  @if (showItemCancel) {
    <button type="button" class="btn-close flex-shrink-0 me-1" aria-label="Close"
            (click)="onCancelClick()"></button>
  }
  @if (uploadStatus.generatingUploadUrl) {
    <fa-icon icon="spinner" animation="spin" class="me-1"/>
  }
  @if (isFileClickable) {
    <button type="button" class="btn btn-link p-0"
            (click)="onFileClick()">
      <ng-template [ngTemplateOutlet]="fileNameText"/>
    </button>
  } @else {
    <ng-template [ngTemplateOutlet]="fileNameText"/>
  }
</div>
@if (!uploadStatus.complete || (showProgressWhileAssociating && !uploadStatus.associated)) {
  <ngb-progressbar [type]="uploadStatus.complete ? 'success' : 'info'" [value]="uploadStatus.progress" [striped]="true"/>
}
<ng-template #fileNameText>
  <div class="text-start text-break">{{uploadStatus.file.name}}</div>
</ng-template>